import { useEffect, useState } from 'react';
import { Autocomplete, createFilterOptions, Grid, IconButton, Paper, Popper, TextField } from '@mui/material';
import { styled, useTheme } from '@mui/material/styles';
import SendIcon from '@mui/icons-material/Send';

const ChatInputLayout = ({
  isFullScreen,
  handleSendPrompt,
  isLoading,
  suggestions,
}) => {
  const theme = useTheme();
  const [inputValue, setInputValue] = useState('');
  const [isHighlighted, setIsHighlighted] = useState(false);
  const [disabled, setDisabled] = useState(true);
  const [options, setOptions] = useState([]);
  const OptionsComponent = styled(Popper)(({ theme }) => ({
    '& .MuiAutocomplete-option': {
      padding: '12px',
      fontSize: '16px',
    },
    '& .MuiAutocomplete-listbox': {
      margin: '0px',
      padding: '0px',
    },
    '& .Mui-focused': {
      backgroundColor: `${theme.palette.primary[600]} !important`,
      color: '#ffffff',
    },
  }));
  const filterOptions = createFilterOptions({
    limit: 5,
    stringify: (option) => option,
  });

  const handleChange = (e, value) => {
    if (e) {
      setInputValue(value);
      setIsHighlighted(false);
    }
  }

  const handleHighlightChange = (e, option) => {
    if (option) setIsHighlighted(true);
  }

  const handleSubmit = async (e) => {
    e.preventDefault();
    handleSendPrompt(inputValue);
    setInputValue('');
    setDisabled(true);
  }

  const handleOnKeyDown = (e) => {
    if (!disabled && !isHighlighted && e.key === 'Enter' && !e.shiftKey) {
      handleSubmit(e);
    }
  };

  useEffect(() => {
    if (isLoading || inputValue.trim() === '') {
      setDisabled(true);
    } else {
      setDisabled(false);
    }
  }, [isLoading, inputValue]);

  useEffect(() => {
    if (suggestions) setOptions([...suggestions]);
  }, [suggestions]);

  return (
    <Grid sx={{
      width: '100%',
      paddingX: isFullScreen ? '10vw' : '25px',
      paddingY: '10px',
      paddingBottom: isFullScreen ? '5vh' : '10px',
    }}>

      <Grid sx={{
        paddingX: '10px',
        paddingY: '05px',
        flexWrap: 'nowrap',
      }}
        container>
        <Grid
          sx={{
            width: '100%',
          }}
        >
          <Autocomplete
            disablePortal
            freeSolo
            onHighlightChange={handleHighlightChange}
            options={options}
            inputValue={inputValue}
            onKeyDown={handleOnKeyDown}
            onInputChange={handleChange}
            PopperComponent={OptionsComponent}
            filterOptions={filterOptions}
            renderInput={(params) => (
              <TextField
                {...params}
                placeholder='Ask me about Connected Services...'
                multiline
                maxRows={3}
                fullWidth
                variant='outlined'
                inputProps={{
                  ...params.inputProps,
                  'aria-label': 'Chat prompt',
                }}
                sx={{
                  '& .MuiOutlinedInput-root': {
                    borderRadius: '15px',
                    padding: '10px',
                    fontSize: '18px',
                    scrollbarColor: `${theme.palette.primary[800]} #ffffff`,
                    scrollbarWidth: 'thin',
                  },
                  '& .MuiInputBase-input': {
                    padding: 0,
                  },
                }}
              />
            )} />
        </Grid>
        <Grid sx={{
          width: 'fit-content',
        }}>
          <IconButton
            type='submit'
            disabled={disabled}
          >
            <SendIcon fontSize='large' />
          </IconButton>
        </Grid>
      </Grid>
    </Grid>
  );
}

export default ChatInputLayout;